<footer class="footer" style="position: fixed !important;">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © BAKNA.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Design & Develop by <a href="https://www.broers.com.co" target="_blank">Broers</a>
                </div>
            </div>
        </div>
    </div>
</footer>